import { type CapiProductPage } from 'types/capi/pdp';

import Link from '~/components/Link';
import usePageData from '~/hooks/usePageData';
import { formatReleaseDate } from '~/utils/dates';
import { formatPrice } from '~/utils/prices';

const InfoItem = ({
  label,
  children
}: {
  children: JSX.Element | string;
  label: string;
}) => {
  return (
    <div className="grid gap-2">
      <div>{label}:</div>
      <div className="font-semibold text-grey-read">{children}</div>
    </div>
  );
};

const ProductInformation = () => {
  const product = usePageData<CapiProductPage>();

  return (
    <div data-cy="product-information" className="grid gap-6 md:gap-10">
      <h2 className="text-lg font-bold">Product information</h2>
      <div className="grid grid-cols-2 gap-8 rounded-lg bg-concrete px-8 py-12 lg:grid-cols-3">
        <InfoItem label="Release date">
          {product.date.released
            ? formatReleaseDate(product.date.released)
            : 'TBC'}
        </InfoItem>
        <InfoItem label="Brand">
          <Link className="underline" to={product.brand_path}>
            {product.brand}
          </Link>
        </InfoItem>
        <InfoItem label="Model">
          <Link className="underline" to={product.model_path}>
            {product.model}
          </Link>
        </InfoItem>
        <InfoItem label="Price">
          {product.price.regular
            ? formatPrice(product.price.regular, product.price.currency)
            : 'Price TBC'}
        </InfoItem>
        <InfoItem label="Style code">{product.style_code || 'TBC'}</InfoItem>
        {product.colour && <InfoItem label="Colour">{product.colour}</InfoItem>}
      </div>
    </div>
  );
};

export default ProductInformation;
